import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const values = [
    {
        title: "Quality Craftsmanship",
        description: "Every piece is meticulously crafted with attention to detail, ensuring lasting beauty and durability for years to come.",
        icon: <AutoAwesomeOutlinedIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    },
    {
        title: "Sustainable Practices",
        description: "Committed to eco-friendly materials and production methods that protect our planet and support a greener future.",
        icon: <SpaOutlinedIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    },
    {
        title: "Unique & Original Designs",
        description: "Stand out with exclusive designs that blend modern trends with timeless elegance, crafted to inspire individuality.",
        icon: <DiamondOutlinedIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    },
    {
        title: "Customer-Centric Service",
        description: "Your satisfaction is our priority. We're here to ensure a delightful shopping experience from start to finish.",
        icon: <SupportAgentOutlinedIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    },
    {
        title: "Ethical Sourcing",
        description: "We partner with suppliers who uphold fair labor practices and responsible material sourcing, ensuring integrity in every stitch.",
        icon: <HandshakeOutlinedIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    },
    {
        title: "Community First",
        description: "We are proud to support local artisans and communities, fostering growth and celebrating cultural heritage through our work.",
        icon: <FavoriteBorderIcon sx={{ fontSize: '1.5rem', color: 'white' }} />
    }
];

const Values = () => {
    return (
        <Box sx={{ py: 15, backgroundColor: '#1a1a1a', color: 'white' }}>
            <Container maxWidth="lg">
                <Grid container spacing={8}>
                    {values.map((value, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <Box
                                component={motion.div}
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.8, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
                            >
                                <Box
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mb: 4
                                    }}
                                >
                                    {value.icon}
                                </Box>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontFamily: "'cormorantgaramond', serif",
                                        fontWeight: 700,
                                        fontSize: '1.8rem',
                                        mb: 2,
                                        color: 'white',
                                        lineHeight: 1.2
                                    }}
                                >
                                    {value.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: "'Sora', sans-serif",
                                        fontSize: '0.875rem',
                                        lineHeight: 1.8,
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        maxWidth: '300px'
                                    }}
                                >
                                    {value.description}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Values;

